import React from 'react';
import ReactDOM from 'react-dom';
import {HanddoApp} from './HanddoApp';
import {loadConfig} from './config/configLoader';

import 'antd/dist/reset.css';     // 1) reset de antd
import 'leaflet/dist/leaflet.css';// 2) estilos de leaflet
import './index.css';
import {DevSupport} from "@react-buddy/ide-toolbox";
import {ComponentPreviews, useInitial} from "./dev";             // 3) tailwind (base/components/utilities)


loadConfig().then(() => {
    ReactDOM.render(<DevSupport ComponentPreviews={ComponentPreviews}
                                useInitialHook={useInitial}
    >
        <HanddoApp/>
    </DevSupport>, document.getElementById('root'));
});